"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _reactAutosuggest = _interopRequireDefault(require("react-autosuggest")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = require("../../../common/styles/Input");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var EMPTY_ARRAY = [];

function shouldRenderSuggestions(a) {
  return 2 <= a.trim().length;
}

function getComparableValue(a) {
  return "string" == typeof a ? a.trim().toLowerCase() : a.value.trim().toLowerCase();
}

function isString(a) {
  return "string" == typeof a;
}

function suggestionsMatch(a, b) {
  return 0 === a.indexOf(b);
}

function getSuggestionValue(a) {
  return a.value || a;
}

function renderSuggestionDecorator(a, b, c) {
  return a[b] ? _react["default"].createElement("div", {
    className: c
  }, a[b]) : null;
}

var AutoComplete = function (a) {
  function b(a) {
    var d;
    if ((0, _classCallCheck2["default"])(this, b), !a.inputProps || !isString(a.inputProps.value) || !a.inputProps.onChange) throw new Error("Must provide an Auto Complete Input with a value and an onChange prop.");
    return d = c.call(this, a), d.checkSuggestionsForPrefixes = (0, _memoizeOne["default"])(function (a) {
      return a.some(function (a) {
        return !!a.prefix;
      });
    }), d.state = {
      suggestions: EMPTY_ARRAY
    }, d.onSuggestionsFetchRequested = d.onSuggestionsFetchRequested.bind((0, _assertThisInitialized2["default"])(d)), d.onSuggestionsClearRequested = d.onSuggestionsClearRequested.bind((0, _assertThisInitialized2["default"])(d)), d.renderSuggestion = d.renderSuggestion.bind((0, _assertThisInitialized2["default"])(d)), d.onChange = d.onChange.bind((0, _assertThisInitialized2["default"])(d)), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "onChange",
    value: function value(a, b) {
      var c = b.newValue,
          d = this.props.inputProps.onChange;
      d({
        target: {
          value: c
        }
      });
    }
  }, {
    key: "onSuggestionsFetchRequested",
    value: function onSuggestionsFetchRequested(a) {
      var b = a.value;
      this.setState({
        suggestions: this.getSuggestions(b)
      });
    }
  }, {
    key: "onSuggestionsClearRequested",
    value: function onSuggestionsClearRequested() {
      this.setState({
        suggestions: EMPTY_ARRAY
      });
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions(a) {
      var b = getComparableValue(a),
          c = this.props.allSuggestions;
      return c.filter(function (a) {
        return suggestionsMatch(getComparableValue(a), b);
      });
    }
  }, {
    key: "renderSuggestion",
    value: function value(a) {
      var b = this.props.renderSuggestion;
      if (b) return b(a);
      var c = "string" == typeof a ? a : a.value;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_Input.AUTO_COMPLETE_OPTION, "auto-suggestion__result")
      }, renderSuggestionDecorator(a, "prefix", _Input.AUTO_COMPLETE_PREFIX), _react["default"].createElement("span", {
        className: _Input.AUTO_COMPLETE_VALUE
      }, c), renderSuggestionDecorator(a, "suffix", _Input.AUTO_COMPLETE_SUFFIX));
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state.suggestions,
          b = this.props,
          c = b.hasPrefix,
          d = b.allSuggestions,
          e = b.inputProps,
          f = this.checkSuggestionsForPrefixes(d);
      return _react["default"].createElement(_reactAutosuggest["default"], (0, _extends2["default"])({}, this.props, {
        inputProps: _objectSpread({}, e, {
          onChange: this.onChange
        }),
        renderSuggestion: this.renderSuggestion,
        shouldRenderSuggestions: shouldRenderSuggestions,
        suggestions: a,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: getSuggestionValue,
        theme: (0, _Input.AUTO_COMPLETE)({
          hasPrefix: c && !f
        })
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = AutoComplete, AutoComplete.defaultProps = {
  renderSuggestion: void 0
};